/**
 * よくあるご質問を印刷するときは、閉じた設問も開いて紙に答えを出す（docs/features/01 §7）。
 *
 * <b>印刷の前（beforeprint）に開き、後（afterprint）で開く前の形に戻す。</b>自分で開いていたものは開いたまま残す。
 * 検索で隠れている設問は紙にも出さない（絞った結果を刷る）。開いても計測には数えない（押して開いたものではない）。
 * スクリプトが動かないときは print.css の <c>::details-content</c> が閉じた答えを見せる。
 */
export const setupFaqPrint = (items: readonly HTMLDetailsElement[], target: Window = window): void => {
    // 印刷のために開いたもの
    let openedForPrint: HTMLDetailsElement[] = [];

    target.addEventListener("beforeprint", () => {
        openedForPrint = items.filter((item) => !item.open);
        for (const item of openedForPrint) item.open = true;
    });
    target.addEventListener("afterprint", () => {
        for (const item of openedForPrint) item.open = false;
        openedForPrint = [];
    });
};
